import React from 'react'
import { Alert } from '@mui/material'

import {
  STORE_RELATION_FORM_ALERT_SX,
  STORE_RELATION_FORM_TEXT
} from '../constants/storeRelationFormConstants'

const StoreRelationFormAlerts = ({
  infoMessage = '',
  onCloseInfo,
  saveErrorMessage = '',
  onCloseSaveError,
  brandValidationAlerts = [],
  onCloseBrandValidation,
  reassignmentWarningMessages = [],
  showBrandAssignmentsDisabledAlert = false
}) => (
  <>
    {infoMessage && (
      <div className="store-relations-form-page-alert store-relations-form-page-alert--info">
        <Alert severity="info" onClose={onCloseInfo} sx={STORE_RELATION_FORM_ALERT_SX}>
          {infoMessage}
        </Alert>
      </div>
    )}

    {saveErrorMessage && (
      <div className="store-relations-form-page-alert">
        <Alert severity="error" onClose={onCloseSaveError} sx={STORE_RELATION_FORM_ALERT_SX}>
          {saveErrorMessage}
        </Alert>
      </div>
    )}

    {brandValidationAlerts.length > 0 && (
      <div className="store-relations-form-page-alert">
        <Alert severity="warning" onClose={onCloseBrandValidation} sx={STORE_RELATION_FORM_ALERT_SX}>
          {brandValidationAlerts.join(' | ')}
        </Alert>
      </div>
    )}

    {reassignmentWarningMessages.length > 0 && (
      <div className="store-relations-form-page-alert">
        <Alert severity="warning" sx={STORE_RELATION_FORM_ALERT_SX}>
          <ol className="store-relations-form-page-alert__list">
            {reassignmentWarningMessages.map((message) => (
              <li key={message} className="store-relations-form-page-alert__list-item">
                {message}
              </li>
            ))}
          </ol>
        </Alert>
      </div>
    )}

    {showBrandAssignmentsDisabledAlert && (
      <div className="store-relations-form-page-alert">
        <Alert severity="warning" sx={STORE_RELATION_FORM_ALERT_SX}>
          {STORE_RELATION_FORM_TEXT.BRAND_ASSIGNMENTS_DISABLED_ALERT}
        </Alert>
      </div>
    )}
  </>
)

export default StoreRelationFormAlerts
